import { getInitialState } from './state';
import { Notification } from '@/utils/helpers/notification';
import { checkinApi } from '@/services/api/httpClient';
import { LOCAL_STORAGE_CPF } from '@/utils/constants/checkin.constants';

const actions = {
  // queries
  async getMdmPatientByCpf({ commit }, cpf) {
    commit('enableLoader', true);

    const url = `/patient/cpf/${cpf}`;
    try {
      const patient = await checkinApi().get(url);
      const mdmData = patient?.data || getInitialState().data;

      commit('SET_MDM_PATIENT_INFO', mdmData);

      return mdmData;
    } catch (error) {
      console.error(error);
    } finally {
      commit('enableLoader', false);
    }
  },

  // queries
  async getMdmPatientById({ getters, commit }, mdmIdPatient) {
    commit('enableLoader', true);

    const mdmPatientId = getters.mdmPatientId || mdmIdPatient;

    const url = `/patient/${mdmPatientId}`;
    try {
      const patient = await checkinApi().get(url);

      const mdmData = patient?.data || getInitialState().data;

      const containsCpfOnDocuments = mdmData?.documents?.filter(
        (document) => document.type === 'CPF',
      );

      if (containsCpfOnDocuments.length) {
        const cpfData = containsCpfOnDocuments[0].value;
        commit('SET_CPF_SEARCHED', cpfData);
      }

      commit('SET_MDM_PATIENT_INFO', mdmData);
      return true;
    } catch (error) {
      return false;
    } finally {
      commit('enableLoader', false);
    }
  },

  async getMdmContactListById({ commit }, id) {
    const url = `/patient/${id}/contacts`;
    try {
      const patient = await checkinApi().get(url);
      commit('SET_MDM_PATIENT_CONTACT_NUMBER_LIST', patient.data.mobilePhoneList);
      commit('SET_MDM_PATIENT_CONTACT_EMAIL_LIST', patient.data.emailList);
    } catch (error) {
      Notification.error({ duration: 6000 });
    }
  },

  // mutations
  async createMdmPatient({ commit, getters }, mdmPatient) {
    commit('enableLoader', true);

    delete mdmPatient.references;

    const url = '/patient';
    try {
      const createdPatient = await checkinApi().post(url, mdmPatient);
      commit('SET_MDM_PATIENT_INFO', createdPatient.data);

      authorizePatient(getters);

      return createdPatient.data;
    } catch (error) {
      console.error(error);
    } finally {
      commit('enableLoader', false);
    }
  },

  async updateMdmPatient({ commit, getters }, mdmPatient) {
    commit('enableLoader', true);

    delete mdmPatient.references;

    const url = '/patient';
    try {
      const updatedPatient = await checkinApi().patch(url, mdmPatient);
      commit('SET_MDM_PATIENT_INFO', updatedPatient.data);

      authorizePatient(getters);

      return updatedPatient.data;
    } catch (error) {
      console.error(error);
    } finally {
      commit('enableLoader', false);
    }
  },

  async createPatientJwt({ getters }) {
    authorizePatient(getters);
  },
};

async function authorizePatient(rootGetters) {
  const cpf = sessionStorage.getItem(LOCAL_STORAGE_CPF);

  try {
    if (!rootGetters?.getCurrentAdmissionState?.data?.id) {
      return;
    }

    const response = await checkinApi().get(
      `/patient/authorization/${cpf}/${rootGetters.getCurrentAdmissionState.data.id}`,
    );

    if (response.data === '') {
      return;
    }

    sessionStorage.setItem('user', response?.data);
  } catch (error) {
    if (error?.response?.status === 401) {
      console.error('Unauthorized cpf access to this admission');
      return;
    }
    throw error;
  }
}

export default actions;
